import React from 'react';
import { Input } from '../../ui/Input';
import { CreatableSelect } from '../../ui/CreatableSelect';
import { useTrainingOptions } from '../../../hooks/useTrainingOptions';
import { parseAmount } from '../../../utils/currency';
import { TrainingCourseDraft } from '../../../types/trainingCourse';
interface CourseCostsFieldsProps {
  draft: TrainingCourseDraft;
  onChange: (changes: Partial<TrainingCourseDraft>) => void;
}
type AmountKey = 'equipmentAmount' | 'roomRentalAmount' | 'otherCostsAmount' | 'externalCostAmount' | 'productionCost';
export function CourseCostsFields({
  draft,
  onChange
}: CourseCostsFieldsProps) {
  const {
    options,
    addOption
  } = useTrainingOptions();
  const amountInput = (key: AmountKey, label: string) => <Input label={label} type="number" min={0} step="0.01" value={draft[key] ?? ''} onChange={e => onChange({
    [key]: parseAmount(e.target.value)
  } as Partial<TrainingCourseDraft>)} endContent={<span className="text-xs" data-id="element-1116" data-mp="3tijq5ewisars">€</span>} data-id="element-1115" data-mp="1xx7gt5487ck" />;
  return <div className="divide-y divide-slate-100" data-id="element-1117" data-mp="3oki6osv6m9fs">
      {draft.status === 'ondemand' && <section className="pb-6" data-id="element-1118" data-mp="3oioxb5t6pb43">
          <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1119" data-mp="3jkngysn57pwb">
            Costo realizzazione corso
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1120" data-mp="3fjab4ik1vmpe">
            {amountInput('productionCost', 'Importo complessivo')}
          </div>
        </section>}
      <section className={draft.status === 'ondemand' ? 'py-6' : 'pb-6'} data-id="element-1121" data-mp="35tqpx68v7grd">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1122" data-mp="30unxcla2n30a">
          Noleggio attrezzature
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1123" data-mp="2vwcmc781imgh">
          <CreatableSelect label="Tipologia" value={draft.equipmentType || ''} onChange={v => onChange({
          equipmentType: v || undefined
        })} options={options.equipmentType} onCreate={v => addOption('equipmentType', v)} placeholder="Seleziona tipologia..." newPlaceholder="Inserisci nuova tipologia" data-id="element-1124" data-mp="2vtzvf4kb11ra" />
          {amountInput('equipmentAmount', 'Importo complessivo')}
        </div>
      </section>

      <section className="py-6" data-id="element-1125" data-mp="23bh11nm45zqs">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1126" data-mp="2887hwd5qszd9">
          Affitto locali
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1127" data-mp="2vxi9p5547jf9">
          {amountInput('roomRentalAmount', 'Importo complessivo')}
        </div>
      </section>

      <section className="py-6" data-id="element-1128" data-mp="30z7n2rft896i">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1129" data-mp="2m8qln836dj9m">
          Altri costi
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1130" data-mp="2r6s53u4ijklm">
          {amountInput('otherCostsAmount', 'Importo complessivo')}
        </div>
      </section>

      <section className="pt-6" data-id="element-1131" data-mp="3ev2wm6obk7x8">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1132" data-mp="3jo4hqwf4d3p9">
          Costo prodotto esterno
        </h3>
        {draft.externalProduct ? <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1133" data-mp="186sqol3bl04j">
            {amountInput('externalCostAmount', 'Importo complessivo del costo del prodotto')}
            <CreatableSelect label="Denominazione fornitore" value={draft.externalSupplier || ''} onChange={v => onChange({
          externalSupplier: v || undefined
        })} options={options.supplier} onCreate={v => addOption('supplier', v)} placeholder="Seleziona fornitore..." newPlaceholder="Inserisci nuovo fornitore" data-id="element-1134" data-mp="1h31ra331a4s9" />
          </div> : <p className="text-sm text-slate-500" data-id="element-1135" data-mp="tb3c380grp9u">
            Disponibile solo con il flag «Acquisto prodotto esterno» attivo
            (in Dati corso).
          </p>}
      </section>
    </div>;
}